module.exports = __webpack_public_path__ + "img/photo.6ddb918b.jpg";